import { useMutation, useQueryClient } from 'react-query';
import {
  ManageCurrentOccupancyPayload,
  ManageCurrentOccupancyResponse
} from 'services/hooks/space-service';

interface ManageCurrentOccupancyProps {
  buildingUuid: string;
  payload: ManageCurrentOccupancyPayload;
}

const useManageOccupancy = ({
  manageCurrentOccupancy,
  queryName,
  onSuccess,
  onError
}: {
  manageCurrentOccupancy: (
    props: ManageCurrentOccupancyProps
  ) => Promise<ManageCurrentOccupancyResponse>;
  queryName: string;
  onSuccess?: (data: ManageCurrentOccupancyResponse) => void;
  onError?: (error: Error) => void;
}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (props: ManageCurrentOccupancyProps): Promise<ManageCurrentOccupancyResponse> => {
      try {
        return await manageCurrentOccupancy(props);
      } catch (error) {
        throw error;
      }
    },
    {
      onSuccess: async (response) => {
        await queryClient.invalidateQueries(queryName);
        await queryClient.invalidateQueries('applessOccupancyEvents');

        if (onSuccess) {
          onSuccess(response);
        }
      },
      onError: async (error: any) => {
        if (onError) {
          onError(error);
        }
      }
    }
  );

  return mutation;
};

export default useManageOccupancy;
